module.exports = __webpack_public_path__ + "img/share1.23ce2443.png";